import axios from "axios";
 const URL = "https://nutrackapi.nubitsoft.com/";
    // const URL = "http://localhost:8000/";
// const URL = "http://192.168.100.15:8000/";


export const getRequest = async (url) => {
  try {
    const response = await axios.get(URL + url);
    return response.data;   //  success response
  } catch (error) {
    console.error("API Error:", error.message);

    // ✅ frontend crash se bacha lo
    return {
      success: false,
      message: error.message || "Server not reachable",
      data: []
    };
  }
};
export const postRequest = async (route,data) => {
    const config = {
      url: URL + route,
      method: "POST",
      headers: {
        "Content-Type": "application/json",   
      },
      data: JSON.stringify(data),
  };
  try {
    const res = await axios.request(config);
    return res.data
  } catch(err) {
    return err.response.data  
  }
};


export const MultiPostRequest = async (route, data) => {
  try {
    const res = await axios.post(`${URL}${route}`, data, {
      headers: {
        //  DON'T set Content-Type manually, let Axios handle it for FormData
      },
    });
    return res.data;
  } catch (err) {
    console.error("MultiPostRequest Error: ", err);
    return err.response?.data || { error: "Unknown error" };
  }
};

export const updateRequest = async (route,data) => {
  const config = {
    url: URL + route,
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
};
try {
  const res = await axios.request(config);
  return res.data
} catch(err) {
  return err.response.data
}
};